import { EventsFilterParams } from "./EventsFilter";
import IFilterEvents from "./IFilterEvents";

class CompaniesFilter implements IFilterEvents {
  filter(params: EventsFilterParams, events: VideoStreamEvent[]): VideoStreamEvent[] {
    if (!params.companies) return events;

    return events.filter((event) => {
      const { companyId } = event;

      return params.companies?.companies.includes(companyId);
    })
  }
}

export default CompaniesFilter;
